import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { productData } from '../../events/sharedSignals';
import { useNavigate } from 'react-router-dom';
import {Dialog} from "@mui/material";
import DocumentPreview from "../../../profile/documents/DocumentPreview";
import {ProductNote} from "../../../../../types/DocumentsTypes/Document";
import JSDB, {NKTypeConvertor} from "../../../../../fromKotlin/nk";
import {createDocument, Details} from "../../../../../types/DocumentsTypes/utils";
import Swal from "sweetalert2";
import LoadingButton from "@mui/lab/LoadingButton";
import {useTheme} from "@mui/material/styles";
import {collect} from "../../../../../api/customer/documents.api";
import {dateObjectToString} from "../../../../../fromKotlin/nkutils";
import {getCustomers} from "../../../../../store/customers/customersSlice";
import {useDispatch} from "react-redux";

const FooterComponent: React.FC = ({products,date,customer,createCustomerDocument,documentType}) => {
    const [total, setTotal] = useState(0);
    const navigate = useNavigate();
    const theme = useTheme();
    const [previewOpen, setPreviewOpen] = React.useState(false);
    const handleNavigateToDeliveryCertificate = () => {
        navigate('/MobileDeliveryCertificate');
    };
    const dispatch = useDispatch();
    const [mainValue, setMainValue] = React.useState<number>(0);
    const [tax, setTaxValue] = React.useState<number>(0);
    console.log(documentType)

    useEffect(() => {;

        setTotal(products.reduce((sum, product) => sum + (product.quantity || 0) , 0));
        const pr = products.filter((p) => p.quantity > 0 || p.quantityReturns > 0 || (p.quantitySecond > 0 && (p.conversion_ratio > 0 || documentType == "order")));

        if (pr.length === 0) {
            setMainValue(0);
            setTaxValue(0);
        }

        const result = JSDB().productDeliveryToAmount(NKTypeConvertor().toKotlinList(collect(pr, Number(customer.id), true, false)), Number(customer.id), dateObjectToString(date));
        setMainValue(JSDB().round(result.third, 2));
        setTaxValue(JSDB().round(result.second, 2));
    }, [products]);
    const [details, setDetails] = React.useState<Details>({
        city: '', companyId: '', companyName: '', email: '', id: 0, phone: '', street: '', streetNumber: ''


    });
    React.useEffect(() => {
        if (!customer) {
            dispatch(getCustomers());
            return;
        }
        setDetails({
            city: customer!.city,
            companyId: customer!.businessId,
            companyName: customer!.businessName,
            email: customer!.email,
            id: Number(customer!.id),
            phone: customer!.phone,
            street: customer!.street,
            streetNumber: customer!.streetNumber
        });

    }, [customer, dispatch]);
    return (
        <>
            <Dialog
                fullWidth
                open={previewOpen ||             createCustomerDocument.data
                }
                maxWidth="lg"
                onBackdropClick={() => {
                    setPreviewOpen(false);

                }}
                sx={{ '& .MuiDialog-paper': { p: 0, xs: { margin: 0, width: '98vw', height: '100vh' } } }}
            >
                <DocumentPreview
                    outerDoc={createCustomerDocument.data ? undefined : undefined}
                    closeFunc={() => {   navigate('/customer/customer-list')}}
                    closeName={createCustomerDocument.data ?  'חזור לרשימת לקוחות':'הנפק'}
                    create = {createCustomerDocument.data ? undefined  : () => {
                        const newDoc = createDocument({
                            date: date ?? new Date(),
                            type: documentType,
                            products: products.filter((p) => p.quantity > 0 || p.quantityReturns > 0 || (p.quantitySecond > 0 && (p.conversion_ratio > 0 || documentType == "order"))),
                            entId: customer.id,
                            status: 'approved',
                            mainValue: mainValue,
                            preValue: mainValue-tax,
                            agent: JSDB().currentAgent,
                            discount: 0,
                            details,
                            comment:'',
                            round: 0,
                            round_tax: 0,
                            deliveryCertificatesIds:[],
                            status: 'approved',
                            payments: [],

                        })

                        Swal.fire({
                            title: 'האם תרצה להנפיק מסמך?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: theme.palette.primary.dark,
                            cancelButtonColor: theme.palette.error.light,
                            confirmButtonText: 'הנפק',
                            cancelButtonText: 'בטל',
                            allowEnterKey: true,
                            allowEscapeKey: true,
                            keydownListenerCapture: true,
                            focusConfirm: true
                        }).then((result) => {
                            if (result.isConfirmed) {

                                createCustomerDocument.mutate(
                                    newDoc
                                );
                            }
                        })

                    }}
                    document={
                        {
                            entId: customer.id,
                            date: date ?? new Date(),
                            type: documentType,
                            entName: customer.name,
                            deliveryCertificatesIds:[],
                            products:
                                ((createCustomerDocument.data) ?
                                    ((documentType == 'delivery_certificate' || documentType == "tax_invoice" || documentType == "invoice" || documentType == "refund") ?
                                        (createCustomerDocument.data as ProductNote[])[0].products : (createCustomerDocument.data as ProductNote).products) : products)
                                    .filter((p) => p.quantity > 0 || p.quantityReturns > 0 || p.forceShow || (p.quantitySecond > 0 && (p.conversion_ratio > 0 || documentType == "order"))),
                            status: ((createCustomerDocument.data) ?
                                ((documentType == 'delivery_certificate' || documentType == "tax_invoice" || documentType == "invoice" || documentType == "refund") ?
                                    (createCustomerDocument.data as ProductNote[])[0].status : (createCustomerDocument.data as ProductNote).status) : 'pending_approval'),
                            id: ((createCustomerDocument.data) ?
                                ((documentType == 'delivery_certificate' || documentType == "tax_invoice" || documentType == "invoice" || documentType == "refund") ?
                                    (createCustomerDocument.data as ProductNote[])[0].id : (createCustomerDocument.data as ProductNote).id) : undefined ?? 0),
                            end: new Date(),
                            details: details,
                            color: '',
                            textColor: '',
                            baseColor: '',
                            round: 0,
                            round_tax: 0,
                            description: '',
                            discount:0,
                            title: ((createCustomerDocument.data) ?
                                ((documentType == 'delivery_certificate' || documentType == "tax_invoice" || documentType == "invoice" || documentType == "refund") ?
                                    (createCustomerDocument.data as ProductNote[])[0].title : (createCustomerDocument.data as ProductNote).title) : 'תעודה חדשה'),
                            allDay: false,
                            nkObject: ((createCustomerDocument.data) ?
                                ((documentType == 'delivery_certificate' || documentType == "tax_invoice" || documentType == "invoice" || documentType == "refund") ?
                                    (createCustomerDocument.data as ProductNote[])[0].nkObject : (createCustomerDocument.data as ProductNote).nkObject) : undefined),
                            onDateChange: (createCustomerDocument.data) ? undefined : undefined,
                            onIdChange: (createCustomerDocument.data) ? undefined : undefined,
                            agent: JSDB().currentAgent,
                            issueDate: new Date(),
                            name: '',
                            mainValue: mainValue,
                            taxValue: tax,
                        }
                    }
                />
            </Dialog>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px',
                    width: '100vw',
                    backgroundColor: 'white',
                    boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 1000
                }}
            >
                {/* Total */}
                <Box sx={{ fontWeight: 'bold', fontSize: '16px', margin: 'auto' }}>סהכ : {total.toFixed(2)}</Box>

                {/* Print Button */}
                <LoadingButton
                    onClick={() => {
                        const newDoc = createDocument({
                            date: date ?? new Date(),
                            type: documentType,
                            products: products.filter((p) => p.quantity > 0 || p.quantityReturns > 0 || (p.quantitySecond > 0 && (p.conversion_ratio > 0 || documentType == "order"))),
                            entId: customer.id,
                            status: 'approved',
                            mainValue: mainValue,
                            preValue: mainValue-tax,
                            agent: JSDB().currentAgent,
                            discount: 0,
                            details,
                            comment:'',
                            round: 0,
                            round_tax: 0,
                            deliveryCertificatesIds:[],
                            status: 'approved',
                            payments: [],
                        })

                        Swal.fire({
                            title: 'האם תרצה להנפיק מסמך?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: theme.palette.primary.dark,
                            cancelButtonColor: theme.palette.error.light,
                            confirmButtonText: 'הנפק',
                            cancelButtonText: 'בטל',
                            allowEnterKey: true,
                            allowEscapeKey: true,
                            keydownListenerCapture: true,
                            focusConfirm: true
                        }).then((result) => {
                            if (result.isConfirmed) {

                                createCustomerDocument.mutate(
                                    newDoc
                                );
                            }
                        })

                    }

                    }
                    loading={createCustomerDocument.isLoading}
                    disabled={createCustomerDocument.isSuccess || products.filter((p) => p.quantity > 0 || p.quantityReturns > 0 || (p.quantitySecond > 0 && (p.conversion_ratio > 0 || documentType == "order"))).length === 0}
                    variant='contained'
                    type='submit'
                    fullWidth
                    sx={{m: 2}}
                >
                    הנפק
                </LoadingButton>

                {/* Save Button */}
                <Button                     loading={createCustomerDocument.isLoading}
                                            disabled={createCustomerDocument.isSuccess || products.filter((p) => p.quantity > 0 || p.quantityReturns > 0 || (p.quantitySecond > 0 && (p.conversion_ratio > 0 || documentType == "order"))).length === 0} sx={{ minWidth: '55vw' }} variant="contained" color="success" onClick={(e)=>{
                    setPreviewOpen(true);
                }}>
                    הצג
                </Button>
            </Box>

        </>

    );
};

export default FooterComponent;
